import React from 'react';
import { Helmet } from 'react-helmet';
import { Innerbanner, Readytotalk } from '../../components';
import Partnership from './PartnerShip';
import ImmersiveRoomAssessment from './Assessment';
import WhatWeOffer from './WhatWeOffer';
import BespokeContent from './Bespoke';
import SoftwarePlatform from './SoftwarePlatform';
import WhyTalk from './WhyTalk';
import Anatomy from './Anatomy';
const bannerdata = {
  img: 'immersiveDocBanner2.png',
  title: 'Take Your Immersive Rooms To The Next Level',
  text: 'Transform Your Training Centres and Workspaces with Immersive Technology',
};

const readytotalk = {
  img: 'MR.jpg',
  title: "Take the Next Step - Let's talk today!",
  text: "Contact us for a consultation and discover how we can enhance your immersive rooms with minimal disruption and maximum impact. Let’s transform your immersive training experience together to make it more efficient, higher fidelity, easy to use and reliable.",
  button: 'Get in Touch',
};
function ImmersiveNew() {
  return (
    <div>
      <Helmet>
        <title>Immersive Rooms | MXR</title>
        <meta
          name='description'
          content='360° Virtual Reality (VR) Tours became a perfect marketing tool in real estate and design. It is particularly useful for those projects that are still in the development stage or under construction.'
        />
      </Helmet>
      <Innerbanner banner={bannerdata} />
      <Partnership />
      <ImmersiveRoomAssessment />
      <WhatWeOffer />
      <BespokeContent />
      <SoftwarePlatform />
      <Anatomy />
      <WhyTalk />
 
      <Readytotalk discuss={readytotalk} />
    </div>
  );
}

export default ImmersiveNew;
